export default __webpack_public_path__ + "static/media/gaeko_mobile.02acc30c.png";